export default __webpack_public_path__ + "aa74c83ed398b5023db862c14e929c49.woff2";